(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('frequently-bought-together')) {
    customElements.define('frequently-bought-together', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-bundle-item]')];
        this.total = this.querySelector('[data-bundle-total]');
        this.button = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.items.forEach((item) => {
          item.querySelector('[data-bundle-check]').addEventListener('change', () => this.update());
          item.querySelector('[data-bundle-variant]').addEventListener('change', () => this.update());
        });
        this.button.addEventListener('click', () => this.addBundle());
        this.update();
      }

      selectedItems() {
        return this.items.filter((item) => {
          const checkbox = item.querySelector('[data-bundle-check]');
          const select = item.querySelector('[data-bundle-variant]');
          return checkbox.checked && !checkbox.disabled && select.value;
        }).map((item) => {
          const select = item.querySelector('[data-bundle-variant]');
          return {id: Number(select.value), quantity: 1, price: Number(select.selectedOptions[0]?.dataset.price || 0)};
        });
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || 'Tk {{amount}}';
        const placeholder = format.match(/\{\{\s*(amount(?:_no_decimals)?)[^}]*\}\}/)?.[0] || '{{amount}}';
        const noDecimals = placeholder.includes('no_decimals');
        const amount = (cents / 100).toLocaleString(undefined, {
          minimumFractionDigits: noDecimals ? 0 : 2,
          maximumFractionDigits: noDecimals ? 0 : 2
        });
        return format.replace(placeholder, amount).replace(/<[^>]*>/g, '');
      }

      update() {
        const items = this.selectedItems();
        this.total.textContent = this.formatMoney(items.reduce((sum, item) => sum + item.price, 0));
        this.button.disabled = !items.length;
      }

      async addBundle() {
        const items = this.selectedItems().map(({id, quantity}) => ({id, quantity}));
        if (!items.length) return;
        const originalText = this.button.textContent;
        this.button.disabled = true;
        this.status.textContent = '';
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items})
          });
          if (!response.ok) throw new Error('bundle-add-failed');
          const cart = await fetch(this.dataset.cartUrl).then((result) => result.json());
          document.querySelectorAll('[data-cart-count]').forEach((count) => count.textContent = cart.item_count);
          this.status.textContent = document.body.dataset.productSuccess;
          const notice = document.querySelector('#CartNotice');
          if (notice) {
            const message = notice.querySelector('[data-cart-notice-message]');
            if (message) message.textContent = document.body.dataset.productSuccess;
            notice.showModal();
          }
        } catch (error) {
          this.status.textContent = document.body.dataset.productError;
        } finally {
          this.button.disabled = false;
          this.button.textContent = originalText;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('impact-slideshow')) {
    customElements.define('impact-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.buttons = [...this.querySelectorAll('[data-slide-button]')];
        this.current = 0;
        this.timer = null;
        this.touchStart = 0;
        this.buttons.forEach((button) => button.addEventListener('click', () => this.show(Number(button.dataset.slideButton), true)));
        this.addEventListener('touchstart', (event) => { this.touchStart = event.changedTouches[0].clientX; }, {passive: true});
        this.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - this.touchStart;
          if (Math.abs(distance) > 45) this.show(this.current + (distance < 0 ? 1 : -1), true);
        }, {passive: true});
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index, true);
        });
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      show(index, manual) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        const timing = this.dataset.autoplay === 'true' && this.slides.length > 1
          && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.buttons.forEach((button, buttonIndex) => {
          const active = buttonIndex === this.current;
          button.classList.toggle('is-active', active);
          button.classList.remove('is-timing');
          button.setAttribute('aria-selected', String(active));
          if (!active) { button.classList.remove('is-resetting'); return; }
          button.classList.add('is-resetting');
          requestAnimationFrame(() => {
            button.classList.remove('is-resetting');
            if (timing) requestAnimationFrame(() => button.classList.add('is-timing'));
          });
        });
        if (manual) { this.stop(); this.start(); }
      }
      start() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = setInterval(() => this.show(this.current + 1, false), Number(this.dataset.delay) || 5000);
      }
      stop() { if (this.timer) clearInterval(this.timer); this.timer = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-compare')) customElements.define('image-compare', class extends HTMLElement { connectedCallback() { this.querySelector('input').addEventListener('input', (event) => this.style.setProperty('--position', `${event.target.value}%`)); } });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => { const root = document.querySelector('[data-collection-root]'); if (!root) return; const panel = root.querySelector('[data-filter-panel]'); const setOpen = state => { panel.classList.toggle('is-open', state); document.body.classList.toggle('filters-open', state); }; root.querySelector('[data-filter-open]')?.addEventListener('click', () => setOpen(true)); root.querySelector('[data-filter-close]')?.addEventListener('click', () => setOpen(false)); root.querySelector('[data-sort-select]')?.addEventListener('change', event => event.currentTarget.form.submit()); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        fetch(this.dataset.url).then((response) => response.text()).then((text) => {
          const element = document.createElement('div');
          element.innerHTML = text;
          const recommendations = element.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.querySelectorAll('[data-reveal]').forEach((element) => element.classList.add('is-visible'));
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', class extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'espybd:recently-viewed';
        this.section = this.querySelector('[data-recently-viewed-section]');
        this.grid = this.querySelector('[data-recently-viewed-grid]');
        this.currentHandle = this.dataset.productHandle;
        this.limit = Number(this.dataset.limit || 4);
        this.load();
      }

      readHandles() {
        try {
          const value = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
          return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
        } catch (error) {
          return [];
        }
      }

      saveCurrent(handles) {
        if (!this.currentHandle) return;
        const updated = [this.currentHandle, ...handles.filter((handle) => handle !== this.currentHandle)].slice(0, 12);
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(updated));
        } catch (error) {
          return;
        }
      }

      async getCard(handle) {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(this.dataset.sectionId)}`);
        if (!response.ok) return '';
        const container = document.createElement('div');
        container.innerHTML = await response.text();
        return container.querySelector('template[data-recently-viewed-card]')?.innerHTML.trim() || '';
      }

      async load() {
        const storedHandles = this.readHandles();
        const handlesToShow = storedHandles.filter((handle) => handle !== this.currentHandle).slice(0, this.limit);
        this.saveCurrent(storedHandles);

        if (!handlesToShow.length) {
          if (window.Shopify?.designMode) {
            this.section.hidden = false;
            this.querySelector('[data-recently-viewed-empty]').hidden = false;
          }
          return;
        }

        const cards = await Promise.all(handlesToShow.map((handle) => this.getCard(handle).catch(() => '')));
        const availableCards = cards.filter(Boolean);
        if (!availableCards.length) return;
        this.grid.innerHTML = availableCards.join('');
        this.grid.querySelectorAll('[data-reveal]').forEach((element) => element.classList.add('is-visible'));
        this.section.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
